import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';
import { hoverOpacity } from '@/utility/theme/animation';

export const NotReleasedOrEndText = styled.div(() =>
  mq({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: ['80px', '80px', '80px', '110px'],
    height: ['56px', '56px', '56px', '68px'],
    color: defaultTheme.text.default,
    fontSize: [
      defaultTheme.font.size.l,
      defaultTheme.font.size.l,
      defaultTheme.font.size.l,
      defaultTheme.font.size.xl,
    ],
    fontWeight: 'bold',
    backgroundColor: defaultTheme.background.white,
    borderRadius: defaultTheme.border.radius.l,
  }),
);

export const BetLink = styled(NotReleasedOrEndText)(() =>
  mq({
    color: defaultTheme.text.white,
    backgroundColor: defaultTheme.background.primary,
    ...hoverOpacity,
  }),
).withComponent(Link);

export const ResultLink = styled(NotReleasedOrEndText)(() =>
  mq({
    color: defaultTheme.color.primary,
    backgroundColor: defaultTheme.background.white,
    border: `2px solid ${defaultTheme.border.color.primary}`,
    ...hoverOpacity,
  }),
).withComponent(Link);

export const Cancel = styled(NotReleasedOrEndText)(() =>
  mq({
    color: defaultTheme.text.gray,
    backgroundColor: defaultTheme.background.mediumGray,
  }),
).withComponent('div');
